export default "__VITE_ASSET__809a9fa5__"